import { defineAction } from "redux-define";
import {
    LOADING, ERROR, SUCCESS, TheApp,
} from "../../constants/stateConstants";

export const users = defineAction("users", [LOADING, ERROR, SUCCESS], TheApp);
export const PATCH = defineAction("PATCH", [LOADING, ERROR, SUCCESS], users);
